/**
 * Icon Mapping Utility for Operations Data
 * 
 * PURPOSE: Convert icon key strings from centralized data
 * to actual React component references.
 * 
 * USAGE:
 *   import { getIcon } from '../utils/iconMapping';
 *   const IconComponent = getIcon('Target');
 *   // Use: <IconComponent className="..." />
 */

import { 
  Target, Clock, AlertTriangle, Layers, Shield,
  TrendingUp, TrendingDown, BarChart3, Truck, Mountain,
  DollarSign, AlertCircle, CheckCircle, FileText, Info,
  Crosshair, Pickaxe, Package, Gem, Factory, Gauge, Eye
} from 'lucide-react';

// Icon mapping object
const iconMap = {
  Target,
  Clock,
  AlertTriangle,
  Layers,
  Shield,
  TrendingUp,
  TrendingDown,
  BarChart3,
  Truck,
  Mountain,
  DollarSign,
  AlertCircle,
  CheckCircle,
  FileText,
  Info,
  Crosshair,
  Pickaxe,
  Package,
  Gem,
  Factory,
  Gauge,
  Eye,
};

/**
 * Get icon component from key string
 * @param {string} iconKey - The icon key (e.g., 'Target', 'Clock')
 * @returns {React.Component|null} The icon component or null if not found
 */
export const getIcon = (iconKey) => {
  return iconMap[iconKey] || null;
};

/**
 * Process keyMessages array to add icon components
 * @param {Array} keyMessages - Array of message objects with iconKey
 * @returns {Array} Same array with icon property added
 */
export const processKeyMessages = (keyMessages) => {
  if (!keyMessages) return [];
  
  return keyMessages.map(msg => ({
    ...msg,
    icon: getIcon(msg.iconKey),
  }));
};

export default iconMap;
